export default "__VITE_ASSET__$KwNty9h__"